<app-life-ins-headline [maInsuranceExtend]="maInsuranceExtend"></app-life-ins-headline>
<div class="life-ins__content">
    <div nxRow>
        <div nxCol="12,12,12,4">
            <app-life-ins-date [maInsuranceExtend]="maInsuranceExtend"></app-life-ins-date>
            <div nxRow class="pair-column" *ngIf="maInsuranceExtend.datePayTo != null">
                <div nxCol="8">{{ 'ma-insurance.life.payToDate' | translate }}</div>
                <div nxCol="4">{{ maInsuranceExtend.datePayTo|dateFormat }}</div>
            </div>
        </div>
        <div nxCol="12,12,12,8">
            <div nxRow *ngFor="let risk of maInsuranceExtend.risk">
                <div nxCol="6">
                    <div class="check-label">
                        <cpc-icon icon="check" [color]="'#70ad47'"></cpc-icon>
                        {{ risk.label }}
                    </div>
                </div>
                <div nxCol="6">
                    <div nxRow class="pair-column">
                        <div nxCol="6">{{ 'ma-insurance.life.sumInsured' | translate }}</div>
                        <div nxCol="6">{{ risk.sumInsured|currencyFormat }}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div nxRow  class="nx-margin-top-m">
        <div nxCol="12,12,12,4">
            <h4 nxHeadline="subsection-xsmall" class="nx-margin-bottom-xs nx-font-weight-semibold fund-headline">
                {{ 'ma-insurance.life.insuranceValue' | translate }}</h4>
            <div nxRow class="pair-column nx-margin-bottom-xs">
                <div nxCol="8">{{ 'ma-insurance.life.totalInsuranceValue' | translate }}</div>
                <div nxCol="4"> {{ maInsuranceExtend.accountValue | currencyFormat }}</div>
            </div>
            <ng-template ngFor let-fund="$implicit" [ngForOf]="maInsuranceExtend.funds">
                <div nxRow *ngIf="fund.bidValue > 0" class="pair-column nx-margin-bottom-3xs">
                    <div nxCol="8">{{ fund.label }} ({{fund.code}})</div>
                    <div nxCol="4">{{ fund.bidValue | currencyFormat }}</div>
                </div>
            </ng-template>
        </div>
        <div nxCol="12,12,12,4">
            <h4 nxHeadline="subsection-xsmall" class="nx-margin-bottom-xs nx-font-weight-semibold fund-headline">
                {{ 'ma-insurance.life.allocationRatio' | translate }}</h4>
            <div nxRow *ngFor="let fundAllocRatio of maInsuranceExtend.fundAllocRatio" class="pair-column nx-margin-bottom-3xs">
                <div nxCol="9">{{ fundAllocRatio.label }} ({{fundAllocRatio.code}})</div>
                <div nxCol="3"> {{ fundAllocRatio.percentage }} %</div>
            </div>
        </div>
        <div nxCol="12,12,12,4">
            <h4 nxHeadline="subsection-xsmall" class="nx-margin-bottom-xs nx-font-weight-semibold fund-headline">
                {{ 'ma-insurance.life.surrender' | translate }}</h4>
            <div nxRow class="pair-column">
                <div nxCol="6">{{ 'ma-insurance.life.surrenderValue' | translate }}</div>
                <div nxCol="6">{{ maInsuranceExtend.surrenderValue | currencyFormat }}</div>
            </div>
            <div nxRow class="pair-column">
                <div nxCol="6">{{ 'ma-insurance.life.surrenderPartialValue' | translate }}</div>
                <div nxCol="6">{{ maInsuranceExtend.maxPsurr | currencyFormat }}</div>
            </div>
        </div>
    </div>

    <div nxRow class="nx-margin-top-s">
        <div nxCol="12">
            <h4 nxHeadline="subsection-xsmall" class="nx-font-weight-semibold fund-headline">{{ 'ma-insurance.life.glossary' | translate }}</h4>
        </div>
        <div nxCol="12,12,12,3">
            <p nxCopytext>{{ 'ma-insurance.life.accountValue' | translate }}</p>
        </div>
        <div nxCol="12,12,12,9">
            <p nxCopytext>{{ 'ma-insurance.life.accountValueText' | translate }}</p>
        </div>
        <div nxCol="12,12,12,3">
            <p nxCopytext>{{ 'ma-insurance.life.redemptionValue' | translate }}</p>
        </div>
        <div nxCol="12,12,12,9">
            <p nxCopytext>{{ 'ma-insurance.life.redemptionValueText' | translate }}</p>
        </div>
        <div nxCol="12,12,12,3">
            <p nxCopytext>{{ 'ma-insurance.life.surrenderPartialValue' | translate }}</p>
        </div>
        <div nxCol="12,12,12,9">
            <p nxCopytext>{{ 'ma-insurance.life.surrenderPartialValueText' | translate }}</p>
        </div>
        <div nxCol="12" class="nx-margin-top-xs">
            <p nxCopytext class="nx-margin-bottom-m">{{ 'ma-insurance.life.rulesText' | translate }}</p>
        </div>
    </div>
</div>